import placeholder from "@/assets/athlete-placeholder.jpg";
import { publicUrl } from "@/lib/storage";

export const athletePlaceholder = placeholder;

export const athleteImageUrl = (imagePath?: string | null): string =>
  publicUrl(imagePath ?? null) ?? placeholder;
